import { Box } from '@mui/material';

import { FicFidcCompositionCard } from './FicFidcCompositionCard';
import { useFollowingViewContext } from '../../../Wallet/FollowingView/FollowingViewContext';
import { useFicFidcCockpitConcentration } from '../concentration/useFicFidcCockpitConcentration';

export function FicFidcManagerConcentrationChart() {
  const { operationId, indicatorsCompetencyDate } = useFollowingViewContext();
  const { status, data } = useFicFidcCockpitConcentration(
    operationId,
    indicatorsCompetencyDate,
  );
  const fallbackData = {
    key: 'manager' as const,
    label: 'Gestor',
    amount: null,
    percentage: null,
    status: status === 'error' ? ('error' as const) : ('unavailable' as const),
    reason:
      status === 'error'
        ? ('source-error' as const)
        : ('missing-metadata' as const),
    competence: null,
    coverage: { total: 0, withMetadata: 0 },
    items: [],
  };

  return (
    <Box
      id="fic-fidc-manager-concentration-chart"
      aria-label="Concentração por gestor"
      sx={{ minWidth: 0 }}>
      <FicFidcCompositionCard
        data={data?.composition.manager ?? fallbackData}
        loading={status === 'loading'}
        testId="fic-fidc-manager-concentration-card"
      />
    </Box>
  );
}
